import { ReactNode } from 'react';
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import SquareFootIcon from '@mui/icons-material/SquareFoot';
import StraightenIcon from '@mui/icons-material/Straighten';

import { RemarkType } from '@carbon/lod3d-viewer/lib/lod3d-viewer';

export enum ConferenceState {
  None = 'none',
  Creating = 'creating',
  Follow = 'follow',
  Explore = 'explore',
}

export const MARK_ICON_MAP: Record<RemarkType, ReactNode> = {
  Annotation: <ChatBubbleIcon />,
  DifferenceMeasurement: <SquareFootIcon />,
  LengthMeasurement: <StraightenIcon />,
  none: null,
  plane: null,
};
